import React from 'react';
import { Outlet } from 'react-router';

import LanguageSwitcher from '@app/dev/terminal/components/languageSwitcher';
import Config from '@app/dev/config/main';

const ClientTransactionLayout = () => (
  <section className="client-transaction-wrapper">
    <div className="client-transaction-header">
      <div className="ct-header-logo" />
      <LanguageSwitcher showFlag />
    </div>
    <div className="client-transaction-content">
      <div className="ct-left">
        <div className="clien-home-banner"> </div>
        {/* <img src={fartbet} alt="client transaction illustration" /> */}
      </div>
      <div className={`ct-right ${Config.clientTransaction.rightSideResize && "resize"}`}>
        <div className="ct-logo" />
        <Outlet />
      </div>
    </div>
  </section>
);

export default ClientTransactionLayout;
